import { AfterContentInit, Component, ContentChildren, QueryList, signal, DestroyRef, inject, Input, Output, EventEmitter, input, linkedSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LiberroTabDirective } from './liberro-tab.directive';

@Component({
  selector: 'liberro-tabs',
  standalone: false,
  templateUrl: './liberro-tabs.component.html',
  styleUrl: './liberro-tabs.component.less',
})
export class LiberroTabsComponent implements AfterContentInit {
  @Input() public largeTabsStyle?: boolean = false;
  @Input() public centerTabs?: boolean = false;
  @Input() public centerDesktopTabs?: boolean = false;
  @Input() public tabsContentPadding?: boolean = true;
  @Input() public hideDivider?: boolean = true;
  @Input() public switchColors?: boolean = false;
  @Input() public headerMaxWidth?: string;
  @Output() public tabIndexChange = new EventEmitter<number>();

  @ContentChildren(LiberroTabDirective) public tabsQueryList!: QueryList<LiberroTabDirective>;
  public tabs = signal<LiberroTabDirective[]>([]);
  public initTabIndex = input<number | null>(); // if any other than first tab should be initiaited
  public selectedTabIndex = linkedSignal<number>(() => this.initTabIndex() ?? 0);
  private destroyRef = inject(DestroyRef);

  public ngAfterContentInit(): void {
    this.tabs.set(this.tabsQueryList.toArray());
    this.tabsQueryList.changes
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.tabs.set(this.tabsQueryList.toArray());
      });
  }

  public selectTab(index: number): void {
    this.selectedTabIndex.set(index);
    this.tabIndexChange.emit(index);
  }

  public isTabActive(index: number): boolean {
    return this.selectedTabIndex() === index;
  }
}
